import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { subscribeConsent } from "../utils/consent";
import {
  ensureKlaviyoScript,
  identifyKlaviyo,
  pageUrl,
  readStoredUserEmail,
  trackClientPageView,
} from "../utils/klaviyo";

export default function KlaviyoTracker({ accountType }) {
  const location = useLocation();

  useEffect(() => {
    const url = pageUrl(location.pathname, location.search);
    const send = () => {
      ensureKlaviyoScript();
      trackClientPageView(url, document.title, accountType);
      const email = readStoredUserEmail();
      if (email) identifyKlaviyo(email);
    };
    send();
    return subscribeConsent(send);
  }, [location.pathname, location.search, accountType]);

  return null;
}
